var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCargoAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66669 16.2673C6.66669 15.925 6.79839 15.5957 7.0345 15.3478L13.5173 8.54088C13.9323 8.10509 14.6667 8.39884 14.6667 9.00065V31.0007C14.6667 31.6025 13.9323 31.8962 13.5173 31.4604L7.0345 24.6535C6.79839 24.4056 6.66669 24.0764 6.66669 23.734V16.2673Z",
    fill: "#0A2432"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1096 8.13033L25.3333 9.33429V12.7634C25.3333 13.0918 25.5725 13.3713 25.8971 13.422L27.2304 13.6304C27.6347 13.6936 28 13.3809 28 12.9717V9.77873L32.2192 10.4819C32.8621 10.5891 33.3333 11.1453 33.3333 11.7971V28.2048C33.3333 28.8566 32.8621 29.4128 32.2192 29.52L28 30.2232V27.4462C28 27.037 27.6347 26.7244 27.2304 26.7875L25.8971 26.9959C25.5725 27.0466 25.3333 27.3261 25.3333 27.6545V30.6676L18.1096 31.8716C17.7032 31.9393 17.3333 31.6259 17.3333 31.214V8.78793C17.3333 8.37597 17.7032 8.0626 18.1096 8.13033Z",
    fill: "#0A2432"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCargoAdd);
export default __webpack_public_path__ + "static/media/cargo_add.473880633638681b50682cf8382b7e76.svg";
export { ForwardRef as ReactComponent };